import { MY_LISTS_PAGE_ROUTE, STATIC_LIST_PAGE_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import ListModalContainer from "app/pages/sales-intelligence/sub-modules/opportunities/containers/ListModal/ListModalContainer";
import type { ReactElement } from "react";
import { useMemo } from "react";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import ContentView from "../../components/common/ContentView/ContentView";
import ListsCard from "../../components/ListsCard/ListsCard";
import ListsResultsView from "../../components/ListsCard/ListsResultsView";
import useListsAssetsCountQueries from "../../queries/useListsAssetsCountQueries";
import useListsQuery from "../../queries/useListsQuery";
import createListsResultsViewModel from "../../services/results-view-model/lists/factory";
import ListsCardActionsContainer from "../ListsCardActionsContainer/ListsCardActionsContainer";

const ListsCardContainer = () => {
    const { data, isLoading, refetch } = useListsQuery();

    useListsAssetsCountQueries(data?.lists ?? []);

    const { results, areResultsOverLimit, metadata } = useMemo(() => {
        return createListsResultsViewModel({ data });
    }, [data]);

    const renderHeaderContent = (): ReactElement | undefined => {
        const shouldShowActions = results.length > 0;

        if (!shouldShowActions) {return;}

        return <ListsCardActionsContainer metadata={metadata} />;
    };

    const handleListCreate = (listId: string) => {
        void refetch();

        proNavigator.go(STATIC_LIST_PAGE_ROUTE, {
            id: listId,
        });
    };

    const handleRedirectToLists = () => {
        proNavigator.go(MY_LISTS_PAGE_ROUTE);
    };

    return (
        <ListsCard
            metadata={metadata}
            headerContent={renderHeaderContent()}
        >
            <ContentView isLoading={isLoading}>
                <ListsResultsView
                    results={results}
                    areResultsOverLimit={areResultsOverLimit}
                    metadata={metadata}
                    onRedirect={handleRedirectToLists}
                />
            </ContentView>
            <ListModalContainer onListCreate={handleListCreate} />
        </ListsCard>
    );
};

export default ListsCardContainer;
